import { type SetStoreState, createStore } from '@seeqdev/utils';
import type { CaptureDialogTarget, EditableCapture } from '@/captures/captures.types';
import type { CaptureOutputV1 } from '@seeqdev/api/model/CaptureOutputV1';

export interface CapturesState {
  /** The capture the dialog is open on, in its mode. */
  openDialog?: CaptureDialogTarget;
}

export interface CapturesActions {
  openCaptureDialog: (capture: CaptureOutputV1) => void;
  openEditDialog: (capture: EditableCapture) => void;
  closeCaptureDialog: () => void;
}

const initialState: CapturesState = {
  openDialog: undefined,
};

const capturesActionsFactory = (set: SetStoreState<CapturesState>): CapturesActions => ({
  openCaptureDialog: (capture) =>
    set((draft: CapturesState) => {
      draft.openDialog = { mode: 'create', capture };
    }),

  openEditDialog: (capture) =>
    set((draft: CapturesState) => {
      draft.openDialog = { mode: 'edit', capture };
    }),

  closeCaptureDialog: () =>
    set((draft: CapturesState) => {
      draft.openDialog = undefined;
    }),
});

const [CapturesStoreProvider, useCapturesStoreInstance, useCapturesSelector] = createStore(
  'Captures',
  initialState,
  capturesActionsFactory,
);

export { CapturesStoreProvider };

export const useOpenCaptureDialog = () => useCapturesSelector((state) => state.openDialog);
export const useOpenCapture = () => useCapturesSelector((state) => state.openDialog?.capture);
export const useCapturesActions = () => useCapturesStoreInstance().actions;
